import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";
import { attempt } from "../../../../service/apiResult";

const apiService = new ApiService();

// Every mutating call below returns an { success, data | error } result rather than the raw
// response-or-error it used to. The axios interceptor rejects with a truthy { statusCode, message },
// so callers checking `if (res)` treated refusals as successes and showed the backend's error text
// in a green success toast — a 409 explaining why a user type could not be deleted read as though
// the deletion had worked.

export const userTypeCreateUpdate = async (data, editMode, id) => {
  const url = editMode === true
    ? `${apiEndPoints.userTypeCreateOrUpdate}/userType/${id}`
    : `${apiEndPoints.userTypeCreateOrUpdate}/userType`;

  return attempt(() => (editMode === true
    ? apiService.update(url, data)
    : apiService.post(url, data)));
}

export const getAlluserType = async (page = 0, size = 10) => {
  try {
    const response = await apiService.get(`${apiEndPoints.getAlluserType}/userType?page=${page}&size=${size}`,);
    return response;
  } catch (error) {
    return error;
  }
};

export const userTypeGetById = async (id) => {
  let result;
  await apiService.get(`${apiEndPoints.userTypeGetById}/userType/${id}`)
    .then((response) => {
      result = response;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const deleteUserType = async (id) =>
  attempt(() => apiService.patch(`${apiEndPoints.deleteUserType}/userType/${id}/status/DELETED`, ''));

export const patchApi = async (id, statusUpdate) =>
  attempt(() => apiService.patch(`${apiEndPoints.patchApi}/userType/${id}/status/${statusUpdate}`, ''));

export const countryMetaData = async () => {
  let result;
  await apiService.get(`${apiEndPoints.countryMetaData}`)
    .then((response) => {
      result = response;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const updateShowOnSignUp = async (id, showOnSignUp) =>
  attempt(() => apiService.patch(`${apiEndPoints.patchApi}/userType/${id}/showOnSignUp/${showOnSignUp}`, ''));

// PIN login (feature/pin-login): OTP or PIN for everyone of this persona, from their next login.
export const updateLoginMethod = async (id, loginMethod) =>
  attempt(() => apiService.patch(`${apiEndPoints.patchApi}/userType/${id}/loginMethod/${loginMethod}`, ''));
